import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React, { FunctionComponent } from 'react';
import { FormState } from '../../../../../hooks/useFormState.types';
import { useTranslation } from '../../../../../hooks/useTranslation';
import CurrencyTextField from '../../../../currency-text-field';
import PaymentLimitsFees from '../../../../paymentus/payment-limits-fees';
import { Model } from '../GuestPaymentForm.rules';
import { isMobile } from '../../../../../util/style-utils';
import EmailTextField from '../../../../email-text-field';
import { formatDate } from '../../../../../util/format';
import useStyles from '../GuestPaymentForm.styles';

interface Props {
  form: FormState<Model>;
  paymentDate: string;
  dueDate: string;
  amountDue?: string;
}

const GuestPaymentInfoSection: FunctionComponent<Props> = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  
  const { form, paymentDate, dueDate } = props;

  return (
    <Grid container>
      <Grid container item xs={12} direction={isMobile() ? 'column' : 'row'}>
        <Grid
          style={{ flexBasis: isMobile() ? 'unset' : '100%' }}
          item
          xs={isMobile() ? 12 : 6}
        >
          <Typography
            variant={'h4'}
            color={'primary'}
            style={{ marginBottom: isMobile() ? 5 : 0 }}
          >
            {t('ENTER_PAYMENT_INFORMATION')}
          </Typography>
        </Grid>
        <Grid
          style={{ flexBasis: isMobile() ? 'unset' : '100%' }}
          container
          xs={isMobile() ? 12 : 6}
          item
          justify={isMobile() ? 'flex-start' : 'flex-end'}
        >
          <Grid item style={{ paddingTop: 1 }}>
            <PaymentLimitsFees></PaymentLimitsFees>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1} style={{ marginTop: '2em'}}>

        <Grid item xs={6}>
        <Grid item xs={12}>
                  <Typography
                    className={classes.colorTextPrimary}
                    variant={'body1'}
                  >
                    {t('PAYMENT_DATE')}
                  </Typography>
                  <Typography
                    className={classes.colorTextPrimary}
                    variant={'subtitle2'}
                  >
                    {paymentDate}
                  </Typography>
                  </Grid>
        </Grid>
        <Grid item xs={6}>
        <Grid item xs={12}>
                  <Typography
                    className={classes.colorTextPrimary}
                    variant={'body1'}
                  >
                    {t('DUE_DATE')}
                  </Typography>
                  <Typography
                    className={classes.colorTextPrimary}
                    variant={'subtitle2'}
                  >
                    {formatDate(new Date(dueDate))}
                  </Typography>
                  </Grid>
          </Grid>
      </Grid>
      
      <Grid container direction="row" spacing={1} style={{ marginTop: '2em'}}>
      <Grid item xs={6} >

        <CurrencyTextField
          style={{marginTop:0, width:'90%'}}
          name={'amount'}
          {...form.props('amount')}
          defaultValue={form.values.amount}
          disabled
        />
        </Grid>
         {props?.amountDue &&
              Number(props?.amountDue) > 0 &&
        (
        <Grid item xs={6}>
          <EmailTextField
            name={'guestEmail'}
            label={t('EMAIL_ADDRESS')}
            autoComplete={t('EMAIL_ADDRESS')}
            inputProps={{ minLength: 1, maxLength: 60 }}
            style={{ width: '100%', margin:0 }}
            {...form.props('guestEmail')}
          />
       
      </Grid>
         )} 
       {props?.amountDue &&
              Number(props?.amountDue) > 0 &&
        ( 
       <Grid item xs={12} className={classes.noteContainer}>
                      <Typography
                        variant={'subtitle2'}
                        style={{ marginRight: '3px' }}
                      >
                        {t('NOTE')}
                      </Typography>
                      <Typography variant={'body2'} style={{ marginTop: '1px' }}>
                        {t('INVOICE_GUEST_PAY_NOTE')}
                      </Typography>
                    </Grid>
         )} 
      </Grid>
                   
      </Grid>
  );
};

export default GuestPaymentInfoSection;
